import type { FieldValues } from "react-hook-form";
import type {
  FieldName,
  ValidArrayField,
} from "src/components/Form/Form.types.ts";
import { SingleField } from "src/components/Form/panels/DefaultFormPanel/SingleField.tsx";
import { FieldRow } from "src/components/Form/panels/DefaultFormPanel/FieldRow.tsx";
import React from "react";

export const PanelField = <FormValues extends FieldValues = FieldValues>({
  name,
}: {
  name: FieldName<FormValues>;
}) => {
  if (isFieldRow(name)) {
    return <FieldRow fields={name} />;
  }
  return <SingleField key={name} name={name} />;
};
const isFieldRow = (name: unknown): name is readonly ValidArrayField[] =>
  Array.isArray(name);
